import { Component, OnInit } from '@angular/core';
import { distinctUntilChanged, pairwise, startWith } from 'rxjs/operators';
import { FormlyType } from '../ga-formly.service';
import { TranslationService } from '../../translation/translation.service';
import { ExtraFieldType } from '../extra-field-type';
import { GaFormlyUtil } from '../ga-formly.util';
import * as _ from 'underscore';

@Component({
  selector: 'formly-field-radio',
  template: `
		<ng-container *ngIf="to.options">
			<div class="radio-control">
				<ng-container *ngFor="let option of to.options; let i = index;">
					<div class="form-check" [class.form-check-inline]="to.inline" [ngClass]="['radio-' + option.id]">
						<label class="form-check-label-wrapper" [class.disabled]="option.disabled">
              <fieldset [disabled]="option.disabled" class="d-inline-block align-top">
                <input
                  class="form-check-input align-middle"
                  [id]="id + '_' + i"
                  [name]="field.name || id"
                  type="radio"
                  [tabIndex]="i"
                  [ngClass]="classNames"
                  [value]="to.valueProp ? option[valueProp] : option"
                  [formControl]="formControl"
                  [formlyAttributes]="field"
                >
                <span [ngClass]="option.labelClass || 'form-check-label'" [innerHTML]="formatLabel(option)"></span>
                <span *ngIf="to.showBusyWhenDisabled && (form.disabled || option.disabled) && (formControl.value && formControl.value[to.trackBy] === option[to.trackBy])" class="col-margin-left"><activity-indicator></activity-indicator></span>
              </fieldset>
						</label>
					</div>
				</ng-container>
			</div>
		</ng-container>
	`
})
export class FormlyFieldRadioComponent extends ExtraFieldType implements OnInit {
  constructor(
    private translationService:TranslationService,
    private formlyUtil: GaFormlyUtil
  ) {
    super();
  }

  public ngOnInit():void {
    // register listener
    this.listen();

    this.classNames = this.formlyUtil.createClassNames(FormlyType.RADIO, <string>this.key, this.to.label);
  }

  public get valueProp():string {
    return <string>this.to.valueProp || 'id';
  }

  public formatLabel(option:any):string {
    const formatFn:Function = this.formlyUtil.getFormatFn(this.to.format);
    return this.translationService.instant(this.to.labelProp? option[ <string>this.to.labelProp ] : formatFn(option));
  }

  protected listen():void {
    // replace the value by one that's in the list
    this.formControl.valueChanges.pipe(
      startWith<any, any>(this.formControl.value),
      distinctUntilChanged(_.isEqual),
      pairwise()
    ).subscribe(([ oldValue, newValue ]:[ any, any ]) => {
      if (this.to.onChange) {
        this.to.onChange(newValue, oldValue);
      }
      this.onValueChange();
    });

    this.to.optionsObserver
      .pipe(
        distinctUntilChanged()
      )
      .subscribe(this.onValueChange);
  }

  private onValueChange = ():void => {
    if (this.to.options?.length && this.formControl.value) {
      const valueInList:any = _.findWhere(this.to.options, { [ this.valueProp ]: this.formControl.value[ this.valueProp ] });

      if (valueInList) {
        this.formControl.patchValue(this.to.valueProp ? valueInList[this.valueProp] : valueInList);
      }
    }
  };
}